import { Component, OnInit, Input } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { IUser } from 'src/app/user-management/user-management-interfaces';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { CreateUserComponent } from 'src/app/building-managment/building-unit-details/create-user/create-user.component';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { FloorManagementService } from 'src/app/floor-management/floor-management.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';

@Component({
  selector: 'app-shared-unit-users-list',
  templateUrl: './shared-unit-users-list.component.html',
  styleUrls: ['./shared-unit-users-list.component.scss'],
})
export class SharedUnitUsersListComponent implements OnInit {
  @Input() usersList!: Observable<IUser[] | undefined>;

  profileImageLoader: string = 'assets/svg/image-loader.gif';
  profileImageSrc: string = 'assets/svg/ico-user-with-gray-circle.svg';
  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;
  siteTimeZone: string | undefined;
  shareedDataSubscription?: Subscription;
  sharedData?: ISharedData;
  siteId!: string;

  constructor(
    private helperService: HelperService,
    private floorManagementService: FloorManagementService,
    public sharedDataService: SharedDataService
  ) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
    this.shareedDataSubscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
        const currentSiteId = this.sharedData?.selectedSite?.siteId;
        this.siteTimeZone = <string>this.sharedData?.selectedSite?.siteTimeZone;
      }
    );
  }

  /**
   * @description: add new user
   * @inut {none}
   * @output {void}
   */
  addUser(): void {
    this.sharedDataService.checkFlag(true);
    const dialogInstance = this.helperService.openModalDialog(
      CreateUserComponent,
      {
        isEditable: false,
        enableBackOperation: false,
        defaultNavigation: CONSTANTS.BUILDING,
        siteTimeZone: this.siteTimeZone,
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );

    dialogInstance?.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.floorManagementService?.setTriggerRerender(true);
      }
    });
  }
}
